module.exports = __webpack_public_path__ + "img/hunt_duih.782549a1.png";